import { Routes, Route } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { VideoDetail } from './pages/VideoDetail';
import { ChannelView } from './pages/ChannelView';
import { History } from './pages/History';
import { Upload } from './pages/Upload';
import { Admin } from './pages/Admin';
import { AuthCallback } from './pages/AuthCallback';
import { useSetupAuthToken } from './lib/auth';
import { ChannelsProvider } from './lib/channels-context';
import { config } from './lib/config';
import { Logo } from './components/Logo';

export function App(): JSX.Element {
  const auth = useAuth();
  const oidcEnabled = !!config.cognito.authority && !!config.cognito.clientId;
  useSetupAuthToken();

  if (oidcEnabled) {
    if (auth?.isLoading) return <div style={{ padding: 30 }}>読み込み中…</div>;
    if (auth?.error) return <SignInPrompt error={auth.error.message} />;
    if (!auth?.isAuthenticated) return <SignInPrompt />;
  }

  return (
    <ChannelsProvider>
      <Routes>
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/videos/:id" element={<VideoDetail />} />
          <Route path="/channels/:id" element={<ChannelView />} />
          <Route path="/mine" element={<History />} />
          <Route path="/upload" element={<Upload />} />
          <Route path="/admin" element={<Admin />} />
        </Route>
      </Routes>
    </ChannelsProvider>
  );
}

function SignInPrompt({ error }: { error?: string }): JSX.Element {
  const auth = useAuth();
  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 30 }}>
      <div className="card" style={{ padding: 32, textAlign: 'center', maxWidth: 400 }}>
        <div style={{ width: 48, height: 48, borderRadius: 12, background: '#fff', border: '1px solid var(--border)', display: 'grid', placeItems: 'center', margin: '0 auto 16px' }}>
          <Logo size={26} />
        </div>
        <h1 style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: 20, margin: '0 0 20px' }}>
          KooTube
        </h1>
        {error && <p style={{ fontSize: 12, color: '#B23A3A', margin: '0 0 16px' }}>{error}</p>}
        <button className="btn" onClick={() => void auth.signinRedirect()} style={{ width: '100%' }}>
          社内SSOでサインイン
        </button>
      </div>
    </div>
  );
}
